<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Reset Password v1 -->
      <b-card class="mb-0">

        <!-- logo -->
        <div class="logo-login logo-login-center">
          <span class="logo-cma-pwd"></span>
        </div>

        <b-card-title class="mb-1">
          {{ $t('RESETPWD.Title') }} 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          {{ $t('RESETPWD.Subtitle') }}
        </b-card-text>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form
            method="POST"
            class="auth-reset-password-form mt-2"
            @submit.prevent="validationForm"
          >

            <!-- password -->
            <b-form-group
              label="Nova Senha"
              label-for="reset-password-new"
            >
              <validation-provider
                #default="{ errors }"
                name="Senha"
                vid="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="reset-password-new"
                    v-model="password"
                    :type="password1FieldType"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    name="reset-password-new"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="password1ToggleIcon"
                      @click="togglePassword1Visibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- confirm password -->
            <b-form-group
              label-for="reset-password-confirm"
              label="Confirmar senha"
            >
              <validation-provider
                #default="{ errors }"
                name="Confirmar senha"
                rules="required|confirmed:Password"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="reset-password-confirm"
                    v-model="cPassword"
                    :type="password2FieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="reset-password-confirm"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="password2ToggleIcon"
                      @click="togglePassword2Visibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              block
              type="submit"
              variant="primary"
            >
              {{ $t('RESETPWD.Send') }}
            </b-button>
          </b-form>
        </validation-observer>

        <p class="text-center mt-2">
          <b-link :to="{name:'login'}">
            <feather-icon icon="ChevronLeftIcon" /> {{ $t('RESETPWD.Back') }}
          </b-link>
        </p>

      </b-card>
    <!-- /Reset Password v1 -->
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BCard, BCardTitle, BCardText, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BLink, BFormInput, BButton,
} from 'bootstrap-vue'
import { required } from '@validations'
import userService from '@/providers/userService'
import messagesNotifyHelper from '@/helpers/messages-notify-helper'
import AppConstants from '@/appConstants'
import jwtDecode from 'jwt-decode'
import { ENUM_LOCALE_LIST } from '@/helpers/locale-helper'

export default {
  components: {
    // VuexyLogo,
    BCard,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      token: '',
      cPassword: '',
      password: '',
      // validation
      required,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
    }
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  mounted() {
      const token = this.$route.query.token;

      try {
        // Check if there is an e-mail and client is true
        const decode = jwtDecode(token);
        if (!decode.email || !decode.auth_system) {
          throw "Invalid token";
        }

        // change lang page
        if (decode.lang) {
          this.$i18n.locale = ENUM_LOCALE_LIST.find(item => item.id == decode.lang).locale;
        }
      } catch (e) {
        let error = {
          message: 'Token inválido'
        };
        messagesNotifyHelper.handleError(error);
      }

      this.token = token;
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const form = {
            token: this.token,
            password1: this.password,
            password2: this.cPassword
          }
          userService.resetPassword(form, new URLSearchParams()).then(() => {
            messagesNotifyHelper.successNotify('Nova senha', 'Senha alterado com sucesso');
            this.$router.push({ path: AppConstants.NAVIGATION_PAGE_LOGIN });
          }).catch(err => {
            console.log(err);
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>

<style lang="scss" scoped>
// Centraliza a logo acima do título (apenas nesta página)
.logo-login-center {
  margin-bottom: 1.5rem;

  .logo-cma-pwd {
    position: relative;
    display: block;
    left: 0;
    margin: 0 auto;
  }
}
</style>
